import * as React from 'react';
import { Grid, Button, Alert, TextLink, Loader } from 'react-unity';
import RequestFormWrapper from '../common/wrappers/RequestFormWrapper';
import UserLookup from '../common/form-controls/Lookups/UserLookup';
import TextAreaField from '../common/form-controls/TextareaField';
import TextInputField from '../../components/common/form-controls/TextInputField';
import CartaInput from '../common/form-controls/Lookups/CartaInput';
import { OnPremObjectTable } from './components/OnPremObjectsTable';
import { OnPremPORTypeInput } from '../OnPremPortOpeningRequests/components/OnPremPORTypeInput';
import { OnPremPORScopeInput } from '../OnPremPortOpeningRequests/components/OnPremPORScopeInput';
import SelectField from '../common/form-controls/SelectField';
import {ToggleField} from '../common/';
import OnPremPORequestObject from '../../models/entities/OnPremPORequestObject';
import {
	OnPremAbstractPORForm,
	AbstractPORFormState,
	AbstractPORFormProps,
	IOnPremObjReqStateForm,
} from './OnPremAbstractPORequestObjectForm';
import AlertModal from '../common/modals/AlertModal';
import SubmitPORequestObjectOnPrem from '../../models/viewModels/OnPremPORequestObjects/SubmitPORequestObjectOnPrem';
import SubmitPortOpeningObjectOnPrem from '../../models/viewModels/OnPremPORequestObjects/SubmitPortOpeningObjectOnPrem';
import ConfirmModal from '../common/modals/ConfirmModal';
import { RuleOperation } from '../../models/enums/POR/RuleOperation';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ReactButton from '../common/ReactButton';
import PortOpeningObjectOnPrem from '../../models/entities/OnPremPortOpeningObject';
import { ApproverInput } from '../PortOpeningRequests/components';
import OnPremObjectRequestService from '../../services/OnPremObjectRequestService';
import ChangeStatusObjectRequestOnPrem from '../../models/viewModels/OnPremPORequestObjects/ChangeStatusObjectRequestOnPrem';
import { OnPremPortOpeningRequestsTypes } from '../../models/enums/POR/OnPremPortOpeningRequestsTypes';
import { Validation } from '../../utils/Validation';
import CartaId from '../../models/entities/CartaId';
import { authenticatedUser } from '../../authentication/authModule';

interface OnPremObjectCreateProps extends OnPremObjectCreateWithParamsProps {}

interface OnPremObjectCreateWithParamsProps extends AbstractPORFormProps {
	draftRequest?: OnPremPORequestObject;
}

interface StateForm extends IOnPremObjReqStateForm {
	selectedScope: string;
	selectedType: string;
}

interface ILocationState {
	selectedObjects?: PortOpeningObjectOnPrem[];
}

interface OnPremObjectCreateWithParamsState extends AbstractPORFormState<StateForm> {
	cancelModalVisible: boolean;
	changeTypeModalVisible: boolean;
	newType: string;
	implementedObjects: PortOpeningObjectOnPrem[];
	underApprovalObjects: PortOpeningObjectOnPrem[];
	loading: boolean;
	loadingImplementedObjects: boolean;
	failedImplementedObjects: boolean;
	selectedFromExisting: string[];
	modalComment: string;
	page: string;
}

interface InvalidObjectResult {
	objectName: string;
	path: string;
}

class MaxNestedLevelError extends Error {
	constructor(message) {
		super(message);
	}
}

class DuplicateNameError extends Error {
	constructor(message) {
		super(message);
	}
}

class OnPremObjectCreateWithParams extends OnPremAbstractPORForm<
	OnPremObjectCreateWithParamsProps,
	OnPremObjectCreateWithParamsState
> {
	OnPremObjectRequestService: OnPremObjectRequestService;

	constructor(props) {
		super(props);
		this.OnPremObjectRequestService = new OnPremObjectRequestService();
		this.state = {
			stateForm: {
				selectedType: '',
				selectedScope: null,
				contact: null,
				trackerID: null,
				firewall: null,
				cartaId: [],
				appEndorser: null,
				justification: '',
				onPremObjects: [],
				approverDOAG: null,
				changeTicketId: null,
				creationDate: new Date(),
				projectAccountUser: null,
				projectId: '',
				ownerDelegate: null,
			},
			endModal: {
				visible: false,
			},
			submissionAlert: {
				visible: false,
			},
			submissionWarned: false,
			operationInProgress: false,
			cancelModalVisible: false,
			changeTypeModalVisible: false,
			newType: null,
			implementedObjects: [],
			loading: true,
			loadingImplementedObjects: true,
			failedImplementedObjects: false,
			loadingTracker: false,
			failedTracker: false,
			underApprovalObjects: [],
			selectedFromExisting: [],
			modalComment: '',
			page: '1',
		};
		this.initFormModel();
	}

	initFormModel() {
		super.initFormModel();

		this.formModel.addField('type', {
			getValue: () => this.state.stateForm.selectedType,
			validation: {
				required: true,
			},
		});

		this.formModel.fields.trackerID.validation = new Validation({
			required: () =>
				this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternalCertConnection.name,
			rules: [
				{
					assert: () => /^[0-9]*$/.test(this.state.stateForm.trackerID?.toString() ?? ''),
					message: 'Only numbers are valid values',
				},
				{
					assert: () => this.state.stateForm.trackerID >= 10000,
					message: 'Tracker ID must be greater than 10000',
				},
			],
		});

		this.formModel.fields.cartaId.validation = new Validation({
			required: () => this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternetDMZ.name,
		});

		this.formModel.fields.appEndorserId.validation = new Validation({
			required: () => this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternetDMZ.name,
		});

		// this.formModel.fields.approverId.validation = new Validation({
		// 	required: () => this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternetDMZ.name,
		// });

		this.formModel.fields.ownerDelegate.validation = new Validation({
			required: () =>
				this.state.stateForm.selectedType === OnPremPortOpeningRequestsTypes.InternalCertConnection.name,
		});
		this.formModel.fields.onPremObjects.getValue = () =>
			this.state.stateForm.onPremObjects.map((obj) => new SubmitPortOpeningObjectOnPrem(obj));
		this.formModel.addField('onPremPortOpeningRequestObjectId', {
			getValue: () => this.props.draftRequest?.id,
		});
	}

	stateFormFromRequest(objRequest: OnPremPORequestObject): StateForm {
		let newState = {
			...super.stateFormFromRequest(objRequest),
			selectedScope: '',
			selectedType: objRequest.type?.name || '',
		};
		return {
			...newState,
			onPremObjects: newState.onPremObjects.map((obj) => {
				return { ...obj };
			}),
		};
	}

	async setImplementedObjects() {
		try {
			const implementedObjects = await this.getCompletedObjects();

			// BUG: This actually returns completed objects, not those under approval
			// const underApprovalObjects = await this.getObjectRequests();

			const underApprovalObjects = []; // It is then used the same way as implementedObjects, so we can skip the computation until the logic is fixed

			this.setState({
				implementedObjects,
				underApprovalObjects,
				loadingImplementedObjects: false,
				failedImplementedObjects: false,
			});
		} catch (error) {
			console.log(error);
			this.setState({
				failedImplementedObjects: true,
			});
			this.handleEndModal(
				'Error while retrieving info, please try again',
				'error',
				5000,
				`/onPremPortOpeningObjects`
			);
		}
	}

	async getAllObjectRequests() {
		return await this.OnPremObjectRequestService.getAll(this.state.page);
	}

	getCompletedObjects = async () => this.OnPremObjectRequestService.getImplementedObjects();

	getFirstInvalidObjectName(nestedObjectNames: string[], allObjects: PortOpeningObjectOnPrem[], maxDepth = 2): InvalidObjectResult | undefined 
	{
  		const objectMap = new Map(
    	allObjects.map(obj => [obj.name, obj]));

  		const findInvalid = (objectName: string, depth: number, visited: Set<string>, path: string[]): InvalidObjectResult | undefined => {
			const current = objectMap.get(objectName);

    		if (!current) {
      			return undefined;
    		}

			path.push(current.name);

    		if (depth > maxDepth) {
      			return {
					objectName: current.name,
					path: path.join(" -> ")
				};
    		}

    		visited.add(objectName);

			const nestedObjects: string[] = current.nestedObjects?.split(",").map(item => item.trim()).filter(Boolean) ?? [];

    		for (const nestedName of nestedObjects ?? []) 
			{
      			if (visited.has(nestedName)) 
				{
        			continue;
      			}

      			const invalid = findInvalid(nestedName, depth + 1, visited, path);

      			if (invalid) 
				{
        			return invalid;
      			}
    		}

    		visited.delete(objectName);
			path.pop();

    		return undefined; 
		};

		for (const nestedName of nestedObjectNames) 
		{
    		const invalid = findInvalid(nestedName,1,new Set<string>(), []);

			if (invalid) {
   	  			return invalid;
			}
		}

  		return undefined;
	}

	async getObjectRequests() {
		const completedObjects = (await this.OnPremObjectRequestService.getCompletedOrPendingObjects())
			.filter(
				(obj) =>
					obj.onPremWorkflowInstance.currentWorkflowInstanceState.onPremWorkflowState.name === 'Completed'
			)
			.flatMap((o) => o.onPremObjects);

		const groupedObjects = completedObjects.reduce((acc, obj) => {
			acc[obj.azureName] = [...(acc[obj.azureName.indexOf[-1]] || []), obj]; // ?
			return acc;
		}, {});

		return Object.values(groupedObjects)
			.filter((data: any) => data[0].operation.name !== 'Remove')
			.map((a) => a[0]);
	}

	async componentDidMount() {
		window.scroll(0, 0);
		if (this.props.draftRequest) {
			this.setState({ stateForm: this.stateFormFromRequest(this.props.draftRequest) });
			if (this.props.draftRequest.type == OnPremPortOpeningRequestsTypes.InternalCertConnection) {
				await this.handleApproverDelegateOptions(this.props.draftRequest.trackerID);
			} else if (this.props.draftRequest.type == OnPremPortOpeningRequestsTypes.InternetDMZ) {
				await this.handleAppEndorserOptions(this.props.draftRequest?.cartaId[0]?.cartaAppId);
			}
		}
		this.setImplementedObjects();
		if (this.props.location.state) {
			const { selectedObjects }: ILocationState = this.props.location.state;
			this.handleStateFormChange(
				'onPremObjects',
				selectedObjects.map((obj) => {
					return { ...obj, operation: RuleOperation.Modify };
				})
			);
			this.setState({
				selectedFromExisting: selectedObjects.map((obj) => obj.name),
			});
		}
		this.setState({ loading: false });
	}

	returningRoute = () => {
		return `/onPremPortOpeningObjects`;
	};

	decisionModalConfirmationField = () => ({
		label: 'Please, provide the reason.',
		value: this.state.modalComment,
		validation: {
			required: true,
		},
		onChange: (ev) => {
			this.setState({
				modalComment: ev.target.value,
			});
		},
	});

	handleCancel = async () => {
		let model: ChangeStatusObjectRequestOnPrem = {
			Successful: false,
			Reason: this.state.modalComment,
		};
		await this.OnPremObjectRequestService.cancel(this.props.draftRequest?.id, model);
		this.setState({
			cancelModalVisible: false,
			operationInProgress: false,
		});
		this.props.navigate('/onPremPortOpeningObjects');
	};

	handleSubmit = async () => {
		this.setSubmissionAlertInProgress('Submitting your request...');
		try {
			if (this.requiresDOAGApproval(this.state.stateForm.selectedType)) {
				const response = await this.verifyApproverLevel(this.state.stateForm?.selectedType);
				if (response && !response.allowed) {
					this.setState({
						operationInProgress: false,
						submissionWarned: true,
						submissionAlert: {
							visible: true,
							text: 'The Approver does not meet the minimum DOAG level required.',
							variant: 'warning',
						},
					});
					return;
				}
			} 
			let model = this.formModel.create(SubmitPORequestObjectOnPrem);
			const duplicatedObjectsInSet = this.getDuplicatesInSet(model.onPremObjects.map((x) => x.name));

			if (duplicatedObjectsInSet.length > 0)
				throw new DuplicateNameError(
					'Duplicated names are not allowed: ' + duplicatedObjectsInSet.join(' || ')
				);

			let newObjects = new Set(
				model.onPremObjects.filter((x) => x.operation == RuleOperation.Add.name).map((x) => x.name)
			);

			// HACK: Deployment Runtime doesn't support Set.intersection method
			function getIntersection<T>(setA: Set<T>, setB: Set<T>): Set<T> {
				return new Set([...setA].filter((item) => setB.has(item)));
			}

			let implementedNames = new Set(this.state.implementedObjects.map((obj) => obj.name));

			let intersection = getIntersection(newObjects, implementedNames);
			if (intersection.size > 0) {
				throw new DuplicateNameError('One or more names already in use: ' + [...intersection].join(' || '));
			}

			let objectsUnderApproval = new Set(this.state.underApprovalObjects.map((obj) => obj.name));

			intersection = getIntersection(newObjects, objectsUnderApproval);
			if (intersection.size > 0) {
				throw new DuplicateNameError(
					'One or more names under approval process: ' + [...intersection].join(' || ')
				);
			}
			
			const invalidName = this.getFirstInvalidObjectName(
  				model.onPremObjects.flatMap(x => x.nestedObjects ? x.nestedObjects.split(',').map(s => s.trim()).filter(Boolean): []),	// names selected in the input
  				this.state.implementedObjects// complete list
			);			

			if (invalidName) 
				throw new MaxNestedLevelError(`The request contains nested objects beyond the supported limit: ${invalidName.path}`);
			
			model.OnPremObjectRequestId = this.props.draftRequest?.id;
			await this.OnPremObjectRequestService.create(model);
			this.handleEndModal(`Your request was submitted successfully.`, 'success', 5000, this.returningRoute());
		} catch (err) {
			const knownErrors = [DuplicateNameError, MaxNestedLevelError];
 			if (knownErrors.some(errorType => err instanceof errorType)) 
				this.setSubmissionAlertError(err.message);
			else 
				this.setSubmissionAlertError(err.response?.data.message ??'An error occurred when processing your request. Please try again later.');				
			}
		finally {
			this.setState({
				operationInProgress: false,
			});
		}
	};

	getDuplicatesInSet(a: string[]) {
		let dupli = [];
		a.reduce((acc, curr) => {
			if (acc.indexOf(curr) === -1 && a.indexOf(curr) !== a.lastIndexOf(curr)) {
				acc.push(curr);
			}
			return acc;
		}, dupli);
		return dupli;
	}

	handleScopeChange = (event: any) => {
		if (this.state.stateForm.onPremObjects.length > 0) {
			this.setState({ changeTypeModalVisible: true, newType: event.target.value });
		} else {
			this.handleStateFormChange('selectedType', event.target.value);
			this.handleStateFormChange('direction', null);
			this.handleStateFormChange('trackerID', null);
			this.handleStateFormChange('approverDOAG', null);
			this.handleStateFormChange('cartaId', []);
			this.handleStateFormChange('appEndorser', null);
			this.handleStateFormChange('approverDelegate', []);
		}
	};

	handleDirectionChange = async (event: any) => {
		this.stateFormHandler().direction.onChange(event);
		await this.setImplementedObjects();
	};

	handleTrackerIdChange = async (event: any) => {
		this.stateFormHandler().trackerID.onChange(event);
	};

	handleCartaIdChange = async (cartaInput: CartaId[]) => {
		this.stateFormHandler().cartaId.onChange(cartaInput);
		await this.setImplementedObjects();
	};

	confirmTypeChange = async () => {
		this.handleStateFormChange('selectedType', this.state.newType);
		this.handleStateFormChange('direction', null);
		this.handleStateFormChange('ruleList', []);
		this.handleStateFormChange('trackerID', null);
		this.handleStateFormChange('approverDOAG', null);
		this.handleStateFormChange('approverDelegate', []);
		this.handleStateFormChange('cartaId', []);
		this.handleStateFormChange('appEndorser', null);
		this.setState({
			changeTypeModalVisible: false,
			newType: null,
		});
		await this.setImplementedObjects();
	};

	objIsAddedAlready(obj: PortOpeningObjectOnPrem): boolean {
		return this.state.stateForm.onPremObjects
			.filter((x) => x.operation.name != 'Add')
			.map((editedObj) => editedObj.azureName)
			.includes(obj.azureName);
	}

	getImplementedObjectsToShow(): PortOpeningObjectOnPrem[] {
		return this.state.implementedObjects.filter(
			(obj) => !this.objIsAddedAlready(obj) && !this.state.selectedFromExisting.includes(obj.name)
		);
	}

	setSelectedFromExisting = (objName: string[]) => {
		this.setState({
			selectedFromExisting: objName,
		});
	};

	isValid = () => {
		return this.formModel.isValid() && (this.props.draftRequest || !this.wasNotEdited());
	};

	isKeepOrRemove = (objectOperation) =>
		objectOperation.operation == RuleOperation.Keep || objectOperation.operation == RuleOperation.Remove;

	/*attestationIsValid = () => {
		return this.props.draftRequest?.isAttestation &&
			this.state.stateForm.onPremObjects.every(this.isKeepOrRemove)
	}*/

	wasNotEdited = () => {
		return this.state.stateForm.onPremObjects.some((obj) => obj.azureName != undefined);
	};

	render() {
		return (
			<>
				<RequestFormWrapper
					title={'New Object Request'}
					linkTree={this.getLinkTree()}
					loading={this.state.loading}
				>
					<p>
						For more information about PORs{' '}
						<TextLink
							className="em-u-margin-right-none"
							external
							target="_blank"
							href="https://fi-gw-policy-portal-git-fi-gateway-policy.apps.rmn01.ocp.na.xom.com/por_landing"
						>
							Click here
						</TextLink>
					</p>
					{this.state.submissionAlert.visible && (
						<Alert variant={this.state.submissionAlert.variant} onClose={this.handleSubmissionAlertClose}>
							{this.state.submissionAlert.text}
						</Alert>
					)}
					<Grid variant="halves">
						<Grid.Item>
							<OnPremPORTypeInput
								type={{
									value: this.state.stateForm.selectedType,
									validation: this.formModel.fields.type.validation,
									onChange: this.handleScopeChange,
									disabled: this.state.operationInProgress,
								}}
							/>
						</Grid.Item>
					</Grid>
					<Grid variant="halves">
						<Grid.Item>
							<OnPremPORScopeInput
								direction={{
									...this.stateFormHandler().direction,
									onChange: this.handleDirectionChange,
								}}
								type={this.state.stateForm.selectedType}
							/>
						</Grid.Item>
					</Grid>
					{this.requiresApproverVerification(this.state.stateForm?.selectedType) && (
						<Grid variant="2-up">
							<Grid.Item>
								<TextInputField
									label="Tracker Id"
									{...this.stateFormHandler().trackerID}
									value={String(this.stateFormHandler().trackerID.value)}
									disabled={this.state.operationInProgress}
									//scope={this.state.stateForm?.selectedType}
									readOnly={this.state.loadingTracker}
									onChange={this.handleTrackerIdChange}
									note={
										this.state.loadingTracker
											? "Validating..."
											: this.state.failedTracker
											? this.state.errorTracker
											: ""
									}
									/* onBlur={ ()=>{
									if (!(this.formModel.fields.trackerID.validation.rules.filter(x=>x.assert()===false).length>0) && !this.state.loadingTracker)
										this.handleApproverDelegateOptions(this.state.stateForm.trackerID)
									}
								} */
								/>
							</Grid.Item>
						</Grid>
					)}
					{this.requiresAppEndorserApproval(this.state.stateForm?.selectedType) && (
						<Alert variant="default">
							<ul className="em-c-bulleted-list">
								<li className="em-c-bulleted-list__item">
									Approver is being pulled from Ardoq based on the App-ID.{' '}
								</li>
								<li className="em-c-bulleted-list__item">
									Eligible approvers are Business Owner, IT Owner, and IT Architect who are active employees.{' '}
									<TextLink
										className="em-u-margin-right-none"
										external
										target="_blank"
										href="https://goto/ARDOQ"
									>
										goto/ARDOQ
									</TextLink>
									{' '} to update role assignments.
								</li>
							</ul>
						</Alert>
					)}
					<Grid variant="2-up">
						<Grid.Item>
							{this.requiresDOAGApproval(this.state.stateForm?.selectedType) && (
								<>
									<ApproverInput
										{...this.stateFormHandler().approverDOAG}
										disabled={this.state.operationInProgress}
										onChange={(selectedApprover) => {
											if (selectedApprover?.id === authenticatedUser.userId) {
												this.setState({
													submissionAlert: {
														visible: true,
														text: 'You cannot select yourself as the DOAG approver.',
														variant: 'warning',
													},
												});
											} else {
												this.setState({
													submissionAlert: {
														visible: false,
													},
												});
											}
											this.stateFormHandler().approverDOAG.onChange(selectedApprover);
										}}
									/>
								</>
							)}
							{this.requiresApproverVerification(this.state.stateForm?.selectedType) && (
								<SelectField
									label="Approver"
									className="full-width"
									{...this.stateFormHandler().ownerDelegate}
									disabled={
										this.state.operationInProgress ||
										this.stateFormHandler().ownerDelegate.options.length == 0 ||
										this.state.loadingTracker
									}
									isLoading={this.stateFormHandler().ownerDelegate.options.length == 0}
									note={
										this.stateFormHandler().ownerDelegate.options.length > 0 ? (
											<></>
										) : (
											<span id="firewallError">
												Approver is being pulled from NCDB based on the Tracker ID and active employee status. goto/NCDB to update role assignments.
											</span>
										)
									}
								/>
							)}
						</Grid.Item>
						<Grid.Item>
							<UserLookup
								label="Technical contact"
								{...this.stateFormHandler().contact}
								disabled={this.state.operationInProgress}
							/>
						</Grid.Item>
					</Grid>
					{this.requiresAppEndorserApproval(this.state.stateForm?.selectedType) && (
						<Grid variant="2-up">
							<Grid.Item>
								<CartaInput
									{...this.stateFormHandler().cartaId}
									disabled={this.state.operationInProgress}
									oneOptionOnly={this.state.stateForm.cartaId.length > 0}
									hideNotes={this.state.operationInProgress}
									onChange={this.handleCartaIdChange}
								/>
							</Grid.Item>
							<Grid.Item>
								<SelectField
									label="Approver (Business Owner, IT Owner, IT Architect)"
									className="full-width"
									{...this.stateFormHandler().appEndorser}
									disabled={
										this.state.operationInProgress ||
										this.stateFormHandler().appEndorser.options.length == 0
									}
									isLoading={this.stateFormHandler().appEndorser.options.length == 0}
									note={
										this.stateFormHandler().appEndorser.options.length == 0 &&
										'First select the DBM'
									}
								/>
							</Grid.Item>
						</Grid>
					)}
					{this.requiresApproverVerification(this.state.stateForm?.selectedType) && (
						<Grid variant="2-up">
							<Grid.Item>
								<ToggleField
									{...this.stateFormHandler().siteCoordination}
									id='siteCoordination'
									label="Site Coordination Required"
									options={[
										{ value: 'true', text: 'Yes' },
										{ value: 'false', text: 'No' },
									]}
									disabled={this.state.operationInProgress}
								/>
							</Grid.Item>
						</Grid>
					)}
					<TextAreaField
						label="Business Justification"
						{...this.stateFormHandler().justification}
						disabled={this.state.operationInProgress}
					/>
					<OnPremObjectTable
						{...this.stateFormHandler().ruleset}
						implementedObjects={this.getImplementedObjectsToShow()}
						loadingImplementedObjects={this.state.loadingImplementedObjects}
						failedImplementedObjects={this.state.failedImplementedObjects}
						selectedFromExisting={this.state.selectedFromExisting}
						setSelectedFromExisting={this.setSelectedFromExisting}
					/>
					<Grid variant="4-up">
						<Grid.Item>
							<Button
								variant="secondary"
								onClick={() => {
									this.setState({
										cancelModalVisible: true,
										operationInProgress: true,
									});
								}}
								disabled={this.state.operationInProgress}
							>
								Cancel Request
							</Button>
						</Grid.Item>
						<Grid.Item />
						<Grid.Item />
						<Grid.Item>
							<ReactButton
								variant="primary"
								disabled={!this.isValid()}
								isLoading={this.state.operationInProgress}
								handleUpdateSubmit={this.handleSubmit}
								loadingVariant="secondary"
								name="Submit Request"
							/>
						</Grid.Item>
					</Grid>
				</RequestFormWrapper>
				<ConfirmModal
					visible={this.state.cancelModalVisible}
					title="Cancel Request?"
					question="Are you sure you want to cancel this request? This operation cannot be undone."
					confirmationField={this.decisionModalConfirmationField()}
					confirmButton={{
						label: 'Yes',
						props: {
							variant: 'primary',
							color: 'negative',
						},
					}}
					cancelButton={{
						label: 'No',
					}}
					onConfirm={this.handleCancel}
					onCancel={() => {
						this.setState({
							cancelModalVisible: false,
							operationInProgress: false,
						});
					}}
				/>
				<ConfirmModal
					visible={this.state.changeTypeModalVisible}
					title="Change Type"
					question="Are you sure you want to continue? If so, the object set will be cleared."
					confirmButton={{
						label: 'Yes',
					}}
					onConfirm={this.confirmTypeChange}
					onCancel={() => {
						this.setState({
							changeTypeModalVisible: false,
						});
					}}
				/>
				<AlertModal {...this.state.endModal} willTimeout={false} onClose={this.endAndRedirect} />
			</>
		);
	}
}

const OnPremPortOpeningRequestsCreate = (props: OnPremObjectCreateProps) => {
	return (
		<OnPremObjectCreateWithParams
			draftRequest={props.draftRequest}
			location={useLocation()}
			navigate={useNavigate()}
			params={useParams()}
		/>
	);
};

export default OnPremPortOpeningRequestsCreate;
